import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Target, Heart, Shield } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

export default function About() {
  const values = [{
    icon: Users,
    title: "Community Focused",
    description: "Built specifically for school PTAs and their unique needs"
  }, {
    icon: Target,
    title: "Goal Oriented",
    description: "Track and achieve your fundraising objectives effectively"
  }, {
    icon: Heart,
    title: "Easy to Use",
    description: "Intuitive interface that anyone can master quickly"
  }, {
    icon: Shield,
    title: "Secure & Compliant",
    description: "GDPR compliant with robust security measures"
  }];
  return <div className="container mx-auto px-4 space-y-12 animate-fade-in pb-16">
      <SEOHead slug="about" />
      <div className="text-center space-y-4">
        <h1 className="text-5xl font-bold text-foreground">Built by PTA Members, for PTA Members</h1>
        <p className="text-xl text-muted-foreground max-w-3xl mx-auto">We understand the challenges because we've lived them. PTA Hub was born from first-hand experience to solve the real-world problems that school PTA committees face every day.</p>
      </div>

      <Card className="shadow-card">
        <CardHeader>
          <CardTitle className="text-3xl">Our Story</CardTitle>
        </CardHeader>
        <CardContent className="prose dark:prose-invert max-w-none space-y-4">
          <p className="text-muted-foreground leading-relaxed">
            The idea for PTA Hub wasn't conceived in a boardroom; it was born in the school hall during late-night 
            event planning and over spreadsheets during budget meetings.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Our founder spent over five years deeply involved in their local PTA, serving in various key roles 
            including Trustee, Treasurer, and ultimately, Chair. Throughout this time, they experienced the passion 
            and dedication that drives PTAs, but also the many frustrations: juggling disconnected tools, chasing 
            paperwork, and struggling to keep everyone on the same page.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            It became clear that there had to be a better way. The idea was born to create a single, unified platform 
            that takes the headaches out of the essential tasks carried out by PTAs, freeing up valuable time and 
            energy to focus on what truly matters: supporting the school and its pupils.
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-card">
        <CardHeader>
          <CardTitle className="text-3xl">Our Mission</CardTitle>
        </CardHeader>
        <CardContent className="prose dark:prose-invert max-w-none space-y-4">
          <p className="text-muted-foreground leading-relaxed">
            Our mission is simple: to empower PTAs with the tools they need to succeed. We aim to replace 
            administrative burdens with streamlined efficiency, allowing committees to focus on creative fundraising, 
            building a strong school community, and making a real difference.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            We are committed to providing an intuitive, powerful, and affordable solution that helps PTAs across the 
            country thrive.
          </p>
        </CardContent>
      </Card>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {values.map((value, i) => {
        const Icon = value.icon;
        return <Card key={i} className="shadow-card text-center">
              <CardHeader>
                <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
                <CardTitle className="text-lg">{value.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{value.description}</p>
              </CardContent>
            </Card>;
      })}
      </div>

    </div>;
}